import { DEFAULT_LOCALE, formatMoneyParam, isMoneyParam } from "../money";

export type WordParams = Readonly<Record<string, unknown>>;

const PLACEHOLDER = /\{(\w+)\}/g;

function render(value: unknown, locale: string): string | undefined {
  if (isMoneyParam(value)) return formatMoneyParam(value, { locale });
  if (typeof value === "string") return value;
  if (typeof value === "number" && Number.isFinite(value)) return new Intl.NumberFormat(locale).format(value);
  return undefined;
}

/**
 * Fills `{name}` placeholders from params: money params are formatted, numbers grouped for the
 * locale. Returns `undefined` when a placeholder has no usable value, so a half-filled sentence
 * is never shown.
 */
export function interpolate(template: string, params: WordParams, locale: string = DEFAULT_LOCALE): string | undefined {
  let complete = true;
  const text = template.replace(PLACEHOLDER, (_match, name: string) => {
    const filled = render(params[name], locale);
    if (filled === undefined) complete = false;
    return filled ?? "";
  });
  return complete ? text : undefined;
}
